/** @jsxImportSource @emotion/react */
import React, { useEffect, useState, useContext, useCallback } from 'react'
import Upload from './Upload'
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, DialogActions, List, ListItem, Modal } from '@mui/material';
import { Typography } from '@mui/material';
import { Link } from '@mui/material';
import { Grid, DialogTitle, DialogContent, Tooltip, IconButton, CircularProgress, Dialog, useTheme, useMediaQuery } from '@mui/material';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { BorderStyle, LocationOn, MyLocation } from '@mui/icons-material';
import ConfirmLocation from './ConfirmLocation';
import Webcam from 'react-webcam';
import Popup, { PopupTitle } from '../CustomPopup';
import { getObjections } from '../../Helper/Functions';
import { Il8nContext } from '../../Helper/i18n';
import getCookie from '../../Helper/Cookies/cookies';
import { convertFourDigitCodeToWord } from '../../Helper/Functions';
import CaptureImg from '../Upload/ImageUpload/CaptureImg';

var isRefreshOn = false
var codeType;
function PhotoProofDialog({ onFile, onFileNew, setSnackBar, ...props }) {
    const [lat, setlat] = useState()
    const [long, setLong] = useState()
    const [img, setImg] = useState()
    const [sending, setSending] = useState()
    const [confirmLocationPopup, setConfirmLocationPopup] = useState(false)
    const [linkSentPopup, setLinkSentPopup] = useState(false)
    const [copiedText, setCopiedText] = useState("")
    const [isCopied, setIsCopied] = useState({ tab1: false, tab2: false })
    const [QRImage, setQRImage] = useState()
    const [sdkData, setSdkData] = useState(null);
    const [validData, setValidData] = useState(false)
    const [openCaptureImgPopup, setOpenCaptureImgPopup] = useState(false)//instructions
    const [photoState, setPhotoState] = useState({ photo: [], capture: false, showLoader: false, sizelimit: false })
    const [recordImgInstruction, setRecordImgInstruction] = useState({
        instructionPopup: false,
        uniqueCode: null,
        word:null
      })
    const [openCaptureImg, setOpenCaptureImg] = useState(false);
    const [openCapturePopup, setOpenCapturePopup] = useState(false);
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const webcamRef = React.useRef(null);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const localeText = useContext(Il8nContext)

    const instructions = [
        localeText?.videoProofinstruction1,
        localeText?.videoProofinstruction2,
        localeText?.videoProofinstruction3,
        localeText?.videoProofinstruction4,
        localeText?.videoProofinstruction5,
        localeText?.videoProofinstruction6
    ];

    const videoConstraints = {
        width: 100,
        height: 100,
        facingMode: "user"
    };


    const classes = {
        modalContent: {
            padding: "0px",
            [theme.breakpoints.down('sm')]: {
                // backgroundColor: theme.palette.secondary.main,
            },
        },
        uploadWrapper: {
            border: "2px dashed #C5C4C4",
            padding: "8px 8px 0px 8px",
            borderRadius: "5px"
        },
        center: {
            textAlign: "center"
        },
        titleDiv: {
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(2)
        },
        title: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 600

        },
        content: {
            marginBottom: theme.spacing(7)
        },
        active: {
            backgroundColor: '#24b7cc',
            padding: "8px 8px 0px 8px",
            height: "100%",
            borderRadius: "5px"
        },
        closeButton: {
            color: '#F54040',
            background: '#F4F4F4'
        },
        notes :{
            '& ul': {
            margin: "0.75em 0",
            padding:" 0 1em",
            listStyle: "none",
          },
          "li": {
            '&:before':{
                content: "",
                borderColor: "#24B7CC",
                borderStyle: "solid",
                borderWidth: "0.35em 0 0.35em 0.45em",
                display: "block",
                height: 0,
                width: 0,
                left: "-1em",
                top: "0.9em",
                position: "relative",
            }
          }
        }
    }

    useEffect(() => {
        if (props.open && document.getElementById("photoFrame")) {
            if (document.getElementById("webcam")) {
                document.getElementById("webcam").style.height = (document.getElementById("photoFrame")?.clientHeight - document.getElementById("photoFrame")?.clientHeight * 0.2) + "px"
                document.getElementById("webcam").style.width = (document.getElementById("photoFrame")?.clientWidth - document.getElementById("photoFrame")?.clientWidth * 0.2) + "px"
            }
            if (document.getElementById("capturedImage")) {
                document.getElementById("capturedImage").style.height = document.getElementById("photoFrame").clientHeight ? (document.getElementById("photoFrame").clientHeight - document.getElementById("photoFrame").clientHeight * 0.2) + "px" : "100%"
                document.getElementById("capturedImage").style.width = document.getElementById("photoFrame").clientWidth ? (document.getElementById("photoFrame").clientWidth - document.getElementById("photoFrame").clientWidth * 0.22) + "px" : "100%"
            }
            if (document.getElementById("imageWebCamDiv")) {
                document.getElementById("imageWebCamDiv").style.top = 10 + "%"
                document.getElementById("imageWebCamDiv").style.left = 12.5 + "%"
            }
        }
    }, [document.getElementById("photoFrame"), img])

    useEffect(() => {
        confirmLocation();
        axios.get(`${process.env.REACT_APP_API_URL}${config.documentMaster + props.masterId}`)
            .then(response => {
                if (response?.data?.success?.documentsReq?.length > 0) {
                    props.setSelectedDocumentMasterData(response?.data?.success?.documentsReq[0])
                }
            }).catch(exception => {
                console.log(exception.message)
            })
    }, [])

    const handleLoadingState = useCallback(() => {
        if (webcamRef?.current && webcamRef?.current?.stream) {
            if (webcamRef?.current?.stream?.active) {
                props.setLoading(false);
            } else {
                props.setLoading(true);
                setSnackBar({ 
                    message: "Please wait for some time until the camera turns ON", 
                    type: "info", 
                    show: true 
                });
            }
        }
    }, [props]);

    useEffect(() => {
        handleLoadingState();
    }, [handleLoadingState()]);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `${process.env.REACT_APP_FACE_SCRIPT}`;
        script.async = true;

        document.head.appendChild(script);

        return () => {
          document.head.removeChild(script);
        };
      }, []);

      const handleSDKData = (data) => {
        setSdkData(data);
        if (data?.is_valid == 1) {
            handleSaveImage(data)
        } else {
            setImg()
            setValidData(true)
            props.setLoading(false);
        }
      };

      const handleGetTokenAndSDKInit = async (isValid) => {
        if (isValid && webcamRef?.current?.stream?.active) {
            capture()
            setOpenCaptureImgPopup(false)
        } else {
            if (webcamRef?.current?.stream?.active) {
                props.setLoading(true);
                const payload = []
                axios.post(process.env.REACT_APP_API_URL + config.generateToken, payload)
                    .then((response) => {
                        if (response?.data?.success) {
                            window.AinxtSDK.Initialize(response?.data?.success?.body?.Token, handleSDKData);
                            setOpenCaptureImgPopup(false)
                        } else if (response?.data?.error) {
                            setSnackBar({ message: response?.data?.error, type: "error", show: true })
                            props.setLoading(false)
                            setImg()
                            setValidData(true)
                            setOpenCaptureImgPopup(false)
                        }
                    })
                    .catch((error) => {
                        setSnackBar({ message: error.message, type: "error", show: true })
                        props.setLoading(false)
                        console.error("Error fetching token:", error);
                        setOpenCaptureImgPopup(false)
                    })
            } else {
                setSnackBar({ message: localeText?.photoProofGrantPermissionforCamera, type: "warning", show: true })
            }
        }
    };

    const confirmLocation = (flag) => {
        navigator.geolocation.getCurrentPosition((position) => {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;
            setlat(latitude)
            setLong(longitude)
        },
            function showError(error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        setSnackBar({ message: localeText?.photoProofGrantPermission, type: "warning", show: true })
                        console.log(localeText?.photoProofSupportedBrowser)
                        break;
                    case error.POSITION_UNAVAILABLE:
                        setSnackBar({ message: localeText?.photoProofSupportedBrowser, type: "warning", show: true })
                        console.log("Geolocation is not supported by your browser.")
                        break;
                    case error.TIMEOUT:
                        setSnackBar({ message: localeText?.photoProofTryAgain, type: "warning", show: true })
                        console.log("The request to get user location timed out.")
                        break;
                    case error.UNKNOWN_ERROR:
                        setSnackBar({ message: localeText?.photoProofErrorOccured, type: "error", show: true })
                        console.log("An unknown error occurred.")
                        break;
                }
            }
        )
    }

    const handleRefresh = (param) => {
        if (param == codeType) {
            if (isRefreshOn) {
                props.setLoading(true)
                axios.get(process.env.REACT_APP_API_URL + config.getDocumentsData)
                    .then(resp => {
                        if (resp.data.success) {
                            props.setLoading(false)
                            let photoDocData = resp.data.success.documentList.filter(item => item.documentTypeCode == "Photo")[0]
                            if (photoDocData?.kycstgProofId?.length > 0) {
                                linkSentPopup && toggleSentLinkPopup()
                                props.handleClose()
                                setSnackBar({ message: localeText?.photoProofDocSuccessfully, type: "success", show: true })
                                props.getDocuments()
                            }
                            else {
                                callRefresh(param)
                            }
                        }
                        else {
                            throw new Error(resp.data.error)
                        }
                    })
                    .catch(err => {
                        props.setLoading(false)
                    })
            }
        }
    }

    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            console.log(imageSrc)
            setImg(imageSrc)
        },
        [webcamRef, lat, long]
    );

    const callRefresh = (param) => {
        if (param == codeType) {
            if (isRefreshOn) {
                setTimeout(() => handleRefresh(param), 5000)
            }
        }
    }

    const handleSaveImage = (data) => {
        if (!data && !sdkData) {
            let dataVal = {}
            dataVal.failureCounter = 0;
            dataVal.is_valid = 0
            props.uploadImageProof([img], 0, undefined, undefined, lat, long, true, dataVal)
        } else {
            props.handleClose()
            props.uploadImageProof(data ? [data?.cropped_image] : [img], 0, undefined, undefined, data ? data?.latitude : lat, data ? data?.longitude : long, true, data ? data : sdkData)
        }
    }

    const generateQRLink = (param) => {
        // setCopiedText()
        codeType = param
        isRefreshOn = false
        let objections = getObjections()
        let payload = {
            "isObjection": !!(objections),
            "sid": (objections?.filter(objection => objection.navigationPath == "/Upload")[0]?.id) || "0",
            "isReUpload":(getCookie("isEmailMobileVerficationFailed") == true) ? true : false
        }
        props.setLoading(true)
        setSending(true)
        axios.post(`${process.env.REACT_APP_API_URL}${config.generateQR}`, payload)
            .then(resp => {
                if (resp.data.success) {
                    props.setLoading(false)
                    setSending(false)
                    setQRImage(resp.data.success)
                    isRefreshOn = true
                    callRefresh(param)
                } else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                setSending(false)
                props.setLoading(false)
                setSnackBar({ message: err.message, type: "error", show: true })
            })
    }

    const toggleSentLinkPopup = () => {
        setLinkSentPopup(!linkSentPopup)
    }

    const copyLink = (text, tab) => {
        navigator?.clipboard?.writeText(text)
            .then(() => {
                if (tab == 1) {
                    setIsCopied({ ...isCopied, tab1: true })
                } else {
                    setIsCopied({ ...isCopied, tab2: true })
                }
            })
            .catch(err => {
                if (tab == 1) {
                    setIsCopied({ ...isCopied, tab1: false })
                } else {
                    setIsCopied({ ...isCopied, tab2: false })
                }
            });
    };

    const generateLink = function (param) {
        // setQRImage()
        codeType = param
        isRefreshOn = false
        setCopiedText("")
        // setIsCopied(false)
        setIsCopied({ tab1: false, tab2: false })
        let objections = getObjections()
        let payload = {
            "isObjection": !!(objections),
            "sid": (objections?.filter(objection => objection.navigationPath == "/Upload")[0]?.id) || "0"
        }
        setSending(true)
        props.setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.sendPhotoCaptureLink, payload)
            .then(resp => {
                if (resp.data.success) {
                    props.setLoading(false)
                    setSending(false)
                    toggleSentLinkPopup()
                    isRefreshOn = true
                    setCopiedText(resp?.data?.photoRequestlink)
                    callRefresh(param)
                } else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                setSending(false)
                props.setLoading(false)
                setSnackBar({ message: err.message, type: "error", show: true })
            })
    }

    const handleClosePopup = () => {
        props.handleClose()
        isRefreshOn = false
    }

    const handleOpenDialogCaputurePopup = () =>{
        if(webcamRef?.current?.stream?.active){
            setOpenCaptureImgPopup(true)
        }else{
            setSnackBar({ message: localeText?.photoProofAllowAccessForCamera, type: "warning", show: true })
        }
    }

    const togglerecordImgInstruction = () => {
        setOpenCaptureImgPopup(false)
    }

    const handleCheckPermissions = () => {
        if(lat && long){
            handlePhotoCapture()
        }
    }

    const handlePhotoCapture = () => {
        props.setLoading(true);
        const payload = { "processType": "photo" }
        axios.post(process.env.REACT_APP_API_URL + config.getUniqueCode, payload)
            .then(resp => {
                if (resp?.data?.success) {
                    let word = convertFourDigitCodeToWord(resp.data.success?.UniqueCode)
                    setRecordImgInstruction({
                        instructionPopup: true,
                        uniqueCode: resp?.data?.success?.UniqueCode,
                        word: word
                    });
                    setPhotoState(prevState => ({ ...prevState, capture: true }));
                    setOpenCaptureImg(true);
                    setOpenCapturePopup(true)
                    props.setLoading(false);
                } else {
                    throw new Error(resp.data.error);
                }
            })
            .catch(err => {
                props.setLoading(false);
                setSnackBar({ message: err.message, type: "error", show: true });
            });
    };

    const handleCloseCaptureImgPopup = () => {
        props.handleClose()
        setOpenCaptureImgPopup(false)
    }

    return <>
        <Dialog {...props} fullWidth={true} maxWidth='md'>
            <DialogTitle >
                <Grid container>
                    <Grid item xs={12} style={{ textAlign: "right" }}>
                        <Grid container>
                            <Grid xs={12}>
                                <Tooltip title="Close" aria-label="close">
                                    <IconButton aria-label="close" onClick={handleClosePopup} size="large">
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={matches ? {} : { padding: "0px" }} className={classes.modalContent}>
                <Grid container >
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography variant={"caption"}>
                            {localeText?.photoProofDocRegulations}
                            {!lat && <span> {localeText?.photoProofDocAnd} <span >{localeText?.photoProofCatch} (<LocationOn style={{ fontSize: "12px" }} /> or <MyLocation style={{ fontSize: "12px" }} />) {localeText?.photoProofShown}<br />
                                {localeText?.photoProofShared}</span></span>}
                        </Typography>
                    </Grid>
                </Grid>
                {!lat && <Grid container style={{ background: "#f5fafc", padding: "15px" }}>
                    {/* <Grid item xs={1} style={{textAlign:"right", paddingTop: "8px"}}>
                            <img src="/images/icon_location.svg"></img>
                        </Grid> */}
                    <Grid item xs={12} md={6} style={{ paddingLeft: "1rem", textAlign: "center" }}>
                        <img src="/images/icon_location.svg"></img>
                        &nbsp;&nbsp;{localeText?.photoProofShareyourLocation}<Button disabled={lat} onClick={() => confirmLocation(true)} variant={"contained"} color={"primary"}>{localeText?.photoProofShareLocation}</Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div style={{ textAlign: "right" }}>
                            <Typography variant={"caption"}>{localeText?.photoProofLocationRelatedHelp}
                                &nbsp;<Link target={"_blank"} href={"https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=en"}>{localeText?.photoProofClickHere}</Link>
                            </Typography>
                        </div></Grid>
                </Grid>}
                <Grid container style={{ padding: "25px" }}>
                    <Grid item xs={12} md={6} style={{ position: "relative" }}>
                        <div style={{ position: "relative", width: "fit-content" }}>
                            <img id="photoFrame" src="/images/PhotoFrame.svg" style={{ maxWidth: isSmallScreen ? "100%" : "max-width" }} />
                            <div id="imageWebCamDiv" style={{ position: "absolute", top: lat ? "166px" : "280px", left: "77px" }}>

                                {img ?
                                    <img id="capturedImage" src={img} style={{ width: "100%", height: "100%" }} />
                                    :
                                    <Webcam
                                        id="webcam"
                                        style={{ width: "100%", height: "100%" }}
                                        audio={false}
                                        // height={300}
                                        ref={webcamRef}
                                        screenshotFormat="image/jpeg"
                                        // width={300}
                                        videoConstraints={videoConstraints}
                                    />
                                }
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" align='center' style={{ fontWeight: "300" }}>{localeText?.photoProofOptionSuitsYourNeed}</Typography>
                        <Grid container spacing={3} style={{ marginBottom: "20px", marginTop: "0px", textAlign: isSmallScreen ? "center" : "inherit" }} >
                            <Grid item xs={12} md={3} ><img src="/images/Take A Picture.svg" /></Grid>
                            <Grid xs={12} md={9} item >
                                <div style={{ marginBottom: "8px" }}><Typography style={{ fontSize: "13px" }} variant={"body1"}>{localeText?.photoProofMakeSureDeviceReady}</Typography> </div>
                                <div>
                                    {img ?
                                        <>
                                            <Button onClick={() => setImg()} style={{ marginRight: "10px", marginBottom: isSmallScreen ? "10px" : "0px" }} variant={"outlined"} color={"primary"} disabled={!lat}>
                                                {localeText?.photoProofTakeNewPictureBtn}
                                            </Button>
                                            <Button onClick={() => handleSaveImage()} variant={"contained"} color={"primary"} disabled={!lat}>
                                                {localeText?.photoProofSaveBtn}
                                            </Button>
                                        </>
                                        :
                                        <Button onClick={validData ?  ()=>handleGetTokenAndSDKInit(validData) : ()=>handleOpenDialogCaputurePopup()} variant={"contained"} color={"primary"} disabled={!lat}>
                                            {localeText?.photoProofTakeAPicture}
                                        </Button>}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} style={{ marginBottom: "20px", textAlign: isSmallScreen ? "center" : "inherit" }}>
                            <Grid item md={3} xs={12} style={{ textAlign: "center" }}><img src="/images/Sent Link.svg" /></Grid>
                            <Grid md={9} xs={12} item >
                                <div style={{ marginBottom: "8px" }}><Typography style={{ fontSize: "13px" }} variant={"body1"}>{localeText?.photoProofUseMyMob}</Typography> </div>
                                <div><Button disabled={sending} onClick={() => generateLink("link")} variant={"contained"} color={"primary"}>{localeText?.photoProofSendLinkBtn}</Button></div>
                            </Grid>
                            {
                                copiedText &&
                                <Grid item md={12} xs={12} marginLeft={1} >
                                    <Grid sx={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', border: '1px solid #ccc', borderRadius: '8px', padding: 0, margin: 0, width: '95%' }}>
                                        <Grid paddingX={1} sx={{ width: '75%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '35px' }}>
                                            <Typography variant="body2" component="span" style={{ display: 'inline-block', width: "100%", whiteSpace: "nowrap", overflow: 'hidden !important', textOverflow: "ellipsis", overflow: 'hidden' }}>{copiedText}</Typography>
                                        </Grid>
                                        <Grid sx={{
                                            backgroundColor: '#d3d3d3', cursor: 'pointer', width: '25%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: '35px',
                                            paddingX: 1,
                                            '&:hover': {
                                                background: '#aeaeae',
                                                color: '#ffff'
                                            },
                                            '&:active': {
                                                background: '#676767',
                                                color: '#ffff'
                                            }
                                        }} onClick={() => copyLink(copiedText, 1)} >
                                            <Typography>{isCopied?.tab1 ? "Copied" : "Copy Text"}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Typography component="div">
                                        <Box sx={{ fontStyle: 'italic', fontSize: '12px', m: 1 }}>Note:- Copy above URL to upload photo / Also send on your mobile number</Box>
                                    </Typography>
                                </Grid>
                            }
                        </Grid>
                        <Grid container spacing={3} style={{ marginBottom: "20px", textAlign: isSmallScreen ? "center" : "inherit" }}>
                            <Grid item md={3} xs={12} style={{ textAlign: "center" }}><img src="/images/Scan QR.svg" /></Grid>
                            <Grid md={9} xs={12} item >
                                <div style={{ marginBottom: "8px" }}><Typography style={{ fontSize: "13px" }} variant={"body1"}>{localeText?.photoProofScanQRCode}</Typography> </div>
                                <div style={{ textAlign: QRImage ? "center" : "inherit" }}>
                                    {QRImage &&
                                        <>
                                            <img height="150" width="150" src={"data:application/image/png;base64," + QRImage} alt="QRImage" />
                                            {!linkSentPopup && <Button style={{ display: "block", margin: "auto" }} onClick={() => handleRefresh("QR")} variant={"outlined"} color={"primary"}>{localeText?.photoProofRefreshPageBtn}</Button>}
                                        </>
                                    }
                                    {!QRImage && <Button disabled={sending} onClick={() => generateQRLink("QR")} variant={"contained"} color={"primary"}>
                                        {sending ? <CircularProgress size={24} style={{ marginRight: '16px', color: '#00000042' }} /> : ""}
                                        {localeText?.photoProofGetQRBtn}
                                    </Button>}
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>

            {confirmLocationPopup && <ConfirmLocation open={confirmLocationPopup}
                closepopup={(lat, long) => {
                    if (lat, long) {
                        setlat(lat);
                        setLong(long);
                        setConfirmLocationPopup(false)
                    } else {
                        setConfirmLocationPopup(false)
                    }
                }} />}
        </Dialog>
        {photoState.capture &&
         <Dialog fullScreen open={openCaptureImgPopup} onClose={() => setOpenCaptureImgPopup(false)}>
            <CaptureImg
                long={long}
                lat={lat}
                matches={props.matches}
                recordImgInstruction={recordImgInstruction}
                uploadImageProof={props.uploadImageProof}
                setSnackBar={setSnackBar}
                onClose={handleCloseCaptureImgPopup}
            />
           </Dialog>}
        <Popup
            open={linkSentPopup}
            maxWidth={"sm"}
        >
            <PopupTitle onClose={toggleSentLinkPopup}>Link Sent!</PopupTitle>
            <DialogContent css={{ textAlign: "center", margin: "0px 30px" }}>
                <Typography>
                    {localeText?.photoProofFollowTheURL}
                </Typography>
                <Button variant="contained" color="primary" css={{ margin: "25px" }} onClick={() => handleRefresh("link")}>
                    {localeText?.photoProofRefreshBtn}
                </Button>
                {
                    copiedText &&
                    <Grid>
                        <Grid sx={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', border: '1px solid #ccc', borderRadius: '8px', padding: 0, margin: 0, width: '95%' }}>
                            <Grid paddingX={1} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', height: '35px' }}>
                                <Typography variant="body2" component="span" style={{ display: 'inline-block', width: "100%", whiteSpace: "nowrap", overflow: 'hidden !important', textOverflow: "ellipsis", overflow: 'hidden' }}>{copiedText}</Typography>
                            </Grid>
                            <Grid sx={{
                                backgroundColor: '#d3d3d3', cursor: 'pointer', width: '25%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: '35px',
                                paddingX: 1,
                                '&:hover': {
                                    background: '#aeaeae',
                                    color: '#ffff'
                                },
                                '&:active': {
                                    background: '#676767',
                                    color: '#ffff'
                                }
                            }} onClick={() => copyLink(copiedText, 2)} >
                                <Typography>{isCopied?.tab2 ? "Copied" : "Copy Text"}</Typography>
                            </Grid>
                        </Grid>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                            <Typography sx={{ fontStyle: 'italic', fontSize: '12px', m: 1 }}>
                                Note:- Copy above URL to upload photo / Also send on your mobile number
                            </Typography>
                        </Box>
                    </Grid>
                }
            </DialogContent>
        </Popup>

        <Popup
            open={openCaptureImgPopup}
            maxWidth={"md"}
        >
            <PopupTitle onClose={togglerecordImgInstruction} customCSS={{ textAlign: "center", color: '#48B7CC', fontSize: '1.40rem', fontWeight: '700' }}> {localeText?.photoProofDocRegulationsTitle}</PopupTitle>
            <DialogContent>
                <Typography style={{ color: "#707070", fontSize: '1.20rem', fontWeight: '700',textAlign:"center" }}>
                    {localeText?.videoProofDocRegulationsTitle}
                </Typography>
                <ol>
                    {instructions.map((instruction, index) => (
                        <li key={index}>
                            <p>{instruction}</p>
                        </li>
                    ))}
                </ol>
                <Typography align='center'>
                    <Button variant="contained" color="primary" justify="center" onClick={() => handleCheckPermissions()}>{localeText?.captureRecordPhoto}</Button>
                </Typography>

            </DialogContent>
        </Popup>
    </>
}

export default (PhotoProofDialog)